import chinaAddressOptions from 'china-division/dist/pca-code.json';

const format = () => {
  let addressOptions = JSON.stringify(chinaAddressOptions);
  addressOptions = addressOptions.replace(/code/g, 'value');
  addressOptions = addressOptions.replace(/name/g, 'label');
  addressOptions = JSON.parse(addressOptions);
  return addressOptions;
};
const options = format();

export default options;



// WEBPACK FOOTER //
// ./src/components/comm/cascader-address-pca-options.js